// Contact information for Glow Lawns
// LOCKED CONTACT CONFIGURATION - VERIFIED

export const CONTACT = {
  // Primary booking phone - WhatsApp enabled
  primaryPhone: "+91-9995450101",
  // Additional support helpline
  supportPhone: "+91-9995830101",
  // All phone numbers
  phones: ["+91-9995450101", "+91-9995830101"],
  
  // WhatsApp configuration - Primary booking number
  whatsappNumber: "919995450101",
  whatsappDisplay: "+91-9995450101",
  
  // Email addresses - VERIFIED
  emails: {
    // Primary booking email - for all booking inquiries
    booking: "bookingglowlawns@gmail.com",
    // Operations & Business related
    operations: "operationglowlawns26@gmail.com",
    // Administration purpose
    admin: "adminglowlawns@gmail.com",
  },
  
  // Address
  address: "Thotillpalam, Chappanthottam, Kozhikode, Kavilumpara, Kerala 673513",
  fullAddress: "Thotillpalam, Chappanthottam, Kozhikode, Kavilumpara, Kerala 673513, Kuttiyadi",
  
  // Google Maps
  googleMapsUrl: "https://www.google.com/maps/search/glowLAWNS+Resorts+%26+Home-stays",
  googleMapsPlusCode: "PR2J+JV Kavilumpara, Kerala",
};

// Generate mailto URL for booking
export function bookingEmailUrl(subject = "", body = "") {
  const params = new URLSearchParams();
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  const queryString = params.toString();
  return `mailto:${CONTACT.emails.booking}${queryString ? '?' + queryString : ''}`;
}

// Generate Outlook compose URL
export function outlookCompose(to, subject = "", body = "") {
  const params = new URLSearchParams();
  params.set("to", to);
  if (subject) params.set("subject", subject);
  if (body) params.set("body", body);
  return `https://outlook.office.com/mail/deeplink/compose?${params.toString()}`;
}

// Generate WhatsApp URL - Primary booking number: +91-9995450101
export function whatsappUrl(message = "") {
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export default CONTACT;
